// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7283329f","455":"aea3f86b","977":"404c461e"}[chunkId] + ".chunk.js";
};